// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"ffbc812f","256":"db1e141e","435":"db1e141e","797":"778d30b2","904":"ffbc812f","973":"420d24f0"}[chunkId] + ".chunk.css";
};